// eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
export enum DISABLED_REASONS {
	WITHDRAW_DISABLED,
	USER_NOT_VERIFIED,
	UNDER_MAINTENANCE,
	NO_WALLET_WITH_ENOUGH_BALANCE,
	RECENT_DEPOSIT_NEEDS_CONFIRMATION,
	FIAT_SEND_UNAVAILABLE,
	WALLET_BALANCE_UNDER_MIN_AMOUNT,
	CASHPLUS_BALANCE_UNUSED
}

export enum SEND_DISABLED_TOOLTIP_TRANSLATIONS {
	USER_NOT_VERIFIED = "action_send_unverified_tooltip",
	MINIMUM_AMOUNT_TO_SEND_IS = "action_send_tooltip",
	YOU_NEED_AT_LEAST_X = "action_fiat_send_not_enough_tooltip",
	SEND_INACTIVE = "action_send_inactive_tooltip",
	UNDER_MAINTENANCE = "action_send_inactive_tooltip",
	RECENT_DEPOSIT_NEEDS_CONFIRMATION = "recent_deposit_disclaimer",
	FIAT_SEND_UNAVAILABLE = "fiat_send_button_tooltip_unavailable",
	CASHPLUS_FUND_AVAIALBLE = "cashplus_fiat_send_balance_tooltip_description"
}

export const disabledTooltipTranslations = new Map<DISABLED_REASONS, SEND_DISABLED_TOOLTIP_TRANSLATIONS>([
	[DISABLED_REASONS.USER_NOT_VERIFIED, SEND_DISABLED_TOOLTIP_TRANSLATIONS.USER_NOT_VERIFIED],
	[DISABLED_REASONS.WITHDRAW_DISABLED, SEND_DISABLED_TOOLTIP_TRANSLATIONS.SEND_INACTIVE],
	[DISABLED_REASONS.UNDER_MAINTENANCE, SEND_DISABLED_TOOLTIP_TRANSLATIONS.UNDER_MAINTENANCE],
	[DISABLED_REASONS.NO_WALLET_WITH_ENOUGH_BALANCE, SEND_DISABLED_TOOLTIP_TRANSLATIONS.MINIMUM_AMOUNT_TO_SEND_IS],
	[
		DISABLED_REASONS.RECENT_DEPOSIT_NEEDS_CONFIRMATION,
		SEND_DISABLED_TOOLTIP_TRANSLATIONS.RECENT_DEPOSIT_NEEDS_CONFIRMATION
	],
	[DISABLED_REASONS.FIAT_SEND_UNAVAILABLE, SEND_DISABLED_TOOLTIP_TRANSLATIONS.FIAT_SEND_UNAVAILABLE],
	[DISABLED_REASONS.WALLET_BALANCE_UNDER_MIN_AMOUNT, SEND_DISABLED_TOOLTIP_TRANSLATIONS.YOU_NEED_AT_LEAST_X],
	[DISABLED_REASONS.CASHPLUS_BALANCE_UNUSED, SEND_DISABLED_TOOLTIP_TRANSLATIONS.CASHPLUS_FUND_AVAIALBLE]
]);
